import { Link } from "react-router-dom";
import LegalLayout, { Section } from "@/components/LegalLayout";

export default function AcceptableUse() {
  return (
    <LegalLayout
      title="Acceptable Use Policy"
      testid="acceptable-use-page"
      path="/acceptable-use"
      intro="This Acceptable Use Policy describes content and conduct that are not allowed on Videoileo. It is part of our Terms of Service. We may suspend or terminate accounts that violate it."
    >
      <Section title="1. Prohibited content">
        <p>You may not create, generate, upload, schedule, or publish content that:</p>
        <p>• Infringes copyright, trademark, publicity, or other intellectual-property rights (see our{" "}
          <Link to="/legal" className="text-blue-400 hover:text-blue-300 underline">Content &amp; Copyright Policy</Link>).</p>
        <p>• Is unlawful, defamatory, fraudulent, or deceptive.</p>
        <p>• Is hateful, harassing, or incites violence or discrimination.</p>
        <p>• Is sexually explicit, exploits or endangers minors, or is otherwise obscene.</p>
        <p>• Promotes self-harm, illegal goods/services, or dangerous activities.</p>
        <p>• Contains malware, phishing, or links intended to harm or defraud.</p>
      </Section>

      <Section title="2. Prohibited conduct">
        <p>You may not:</p>
        <p>• Impersonate any person or organization, or misrepresent your affiliation.</p>
        <p>• Generate voiceovers that imitate a real person's voice or likeness without their explicit consent.</p>
        <p>• Use the Service to create spam, mass-duplicated, or misleading low-quality content at scale.</p>
        <p>• Reverse engineer, scrape, or attempt to extract source code or models.</p>
        <p>• Abuse, automate, or circumvent the credit system, rate limits, or access controls.</p>
        <p>• Interfere with or disrupt the integrity or performance of the Service.</p>
      </Section>

      <Section title="3. Synthetic media &amp; disclosure">
        <p>Content produced with Videoileo is AI-generated. Where required by law or platform policy, you must disclose that voices and visuals are synthetic. Do not use synthetic media to deceive, defraud, or manipulate.</p>
      </Section>

      <Section title="4. Platform compliance">
        <p>When publishing to YouTube, TikTok, Instagram, or other services, you must follow their community guidelines and copyright rules in addition to this policy. Repeated violations on those platforms may result in strikes or termination of your accounts there.</p>
      </Section>

      <Section title="5. Reporting &amp; enforcement">
        <p>If you believe content created with Videoileo violates this policy or your rights, contact support@videoileo.com. We may remove content, and suspend or terminate accounts, at our discretion to protect users and comply with the law.</p>
      </Section>
    </LegalLayout>
  );
}
